import React, { useState, useEffect } from 'react';
import styles from './userDetails.module.scss';
import { Col, Form, Row } from 'react-bootstrap';
import * as yup from 'yup';
import { Formik } from 'formik';
import { CustomTextField } from '../../../../shared/customTextField';
import { CustomButton } from '../../../../shared/customButton';
import { CustomDropdown } from '../../../../shared/customDropdown';
import { addNewUser,updateUser } from "../../../../../services/util/userManagement";
import { toast } from 'react-toastify';

const UserDetails = (props) => {

    const
        dropValue = [
            {
                label: 'Admin',
                value: 0,
            },
            {
                label: 'Recruiter',
                value: 10,
            },
            {
                label: 'Reviewer',
                value: 20,
            },
        ]

    let [userRoleType,setUserRoleType] = useState();
    let [userPermissionsByRoleType, setUserPermissionsByRoleType] = useState([]);
    const [isSubmittedActionPending, setIsSubmittedActionPending] = useState(false);

    //yup validations
    const schema = yup.object({
        userEmail: yup.string().trim().email('Invalid email').matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
        userRole: yup.number().required('Required'),
    });

    const submitDetails = async (values) => {
        setIsSubmittedActionPending(true);

        let results= {}
        if(props.isCreateMode){
            results = await addNewUser(
                values.userEmail,
                values.userRole
            );
        }
        else{
            results = await updateUser(
                props.userDetails.userID,
                values.userRole
            );
        }

        if (results.success === true) {
            setIsSubmittedActionPending(false);
            props.reloadUsers();
            props.handleClose();
            toast.success(<div><i className="fas fa-check fa-lg"></i>&nbsp;&nbsp;Invitation Send Successfully</div>, {
                position: "top-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else {
            setIsSubmittedActionPending(false);
            toast.warning(<div><i className="fas fa-check fa-lg"></i>&nbsp;&nbsp;Invitation Failed!</div>, {
                position: "top-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }

    };

    const captureUserRoleType = (type) => {
        setUserRoleType(type);
        if(type==0){
            setUserPermissionsByRoleType(props.userRolePermissions?.admin)
        }
        else if(type==10){
            setUserPermissionsByRoleType(props.userRolePermissions?.recruiter)
        }
        else if(type==20){
            setUserPermissionsByRoleType(props.userRolePermissions?.reviewer)
        }
    }

    useEffect(() => {
        captureUserRoleType(props.userDetails.userRole)
    }, []);

    return (
        <div>
            <Formik
                validationSchema={schema}
                onSubmit={(values) => submitDetails(values)}
                initialValues={{ userEmail: props.userDetails.email ? props.userDetails.email :'', userRole: (props.userDetails.userRole>=0) ? props.userDetails.userRole :'' }}
            >
                {({
                    values,
                    errors,
                    handleChange,
                    handleSubmit,
                    submitCount,
                    setFieldValue
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Row>
                            <Col className={styles.modalInputRow}>
                                <CustomTextField
                                    label="Email"
                                    controlId="userEmail"
                                    type="text"
                                    name="userEmail"
                                    placeholder="New user's email. ex:- anna@gmail.com"
                                    value={values.userEmail}
                                    handleOnChange={handleChange}
                                    errorMessage={errors.userEmail}
                                    isInvalid={submitCount > 0 && !!errors.userEmail}
                                    disabled={!props.isCreateMode} // Disable the field when isCreateMode is false
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col className={styles.modalInputRow}>
                                <CustomDropdown
                                    label="User Role"
                                    controlId="userRole"
                                    name="userRole"
                                    value={values.userRole}
                                    handleOnChange={(e) => { setFieldValue('userRole', parseInt(e.target.value)); captureUserRoleType(parseInt(e.target.value)) }}
                                    dropdownValues={dropValue}
                                    errorMessage={errors.userRole}
                                    isInvalid={submitCount > 0 && !!errors.userRole}
                                    hiddenOption="Select User Role"
                                />
                            </Col>

                        </Row>
                        {<Row>
                                <div>
                                    {userRoleType ==0 &&  <p className={styles.permissionTypeInfo}>Has all the permissions (including company settings, billing)</p>}
                                    {userRoleType ==10 && <p className={styles.permissionTypeInfo}>Has all the other permissions except company settings, manage users and billing</p>}
                                    {userRoleType ==20 && <p className={styles.permissionTypeInfo}>Limited permissions. Review candidate capabilities only</p>}
                                </div>
                                <div>
                                    {userPermissionsByRoleType.slice(0, 3).map((permissions, i) => (
                                        <p key={i} className={permissions?.is_enabled ? styles.allowedPermissionLabel : styles.notAllowedPermissionLabel} >
                                            {permissions?.label}
                                        </p>
                                    ))}
                                </div>
                                <div>
                                    {userPermissionsByRoleType.slice(3, 6).map((permissions, i) => (
                                        <p
                                            key={i}
                                            className={permissions?.is_enabled ? styles.allowedPermissionLabel : styles.notAllowedPermissionLabel}
                                        >
                                            {permissions?.label}
                                        </p>
                                    ))}
                                </div>
                                <div>
                                    {userPermissionsByRoleType.slice(6, 9).map((permissions, i) => (
                                        <p
                                            key={i}
                                            className={permissions?.is_enabled ? styles.allowedPermissionLabel : styles.notAllowedPermissionLabel}
                                        >
                                            {permissions?.label}
                                        </p>
                                    ))}
                                </div>
                                <div>
                                    {userPermissionsByRoleType.slice(9, 13).map((permissions, i) => (
                                        <p
                                            key={i}
                                            className={permissions?.is_enabled ? styles.allowedPermissionLabel : styles.notAllowedPermissionLabel}
                                        >
                                            {permissions?.label}
                                        </p>
                                    ))}
                                </div>
                                <div className={styles.permissionRowDiv}>
                                    {userPermissionsByRoleType.slice(13, 15).map((permissions, i) => (
                                        <p
                                            key={i}
                                            className={permissions?.is_enabled ? styles.allowedPermissionLabel : styles.notAllowedPermissionLabel}
                                        >
                                            {permissions?.label}
                                        </p>
                                    ))}
                                </div>
                                <div>
                                    {userPermissionsByRoleType.slice(15, 17).map((permissions, i) => (
                                        <p
                                            key={i}
                                            className={permissions?.is_enabled ? styles.allowedPermissionLabel : styles.notAllowedPermissionLabel}
                                        >
                                            {permissions?.label}
                                        </p>
                                    ))}
                                </div>
                                <div>
                                    {userPermissionsByRoleType.slice(17, 20).map((permissions, i) => (
                                        <p
                                            key={i}
                                            className={permissions?.is_enabled ? styles.allowedPermissionLabel : styles.notAllowedPermissionLabel}
                                        >
                                            {permissions?.label}
                                        </p>
                                    ))}
                                </div>
                            </Row>
                        }

                        <Row >
                            <Col className={styles.dividerRow}>
                                <hr />
                            </Col>
                        </Row>
                        
                        <Row >
                            <Col className={styles.actionBtnRow}>
                                <div className='d-flex flex-row-reverse'>
                                    <div >
                                        {props.isCreateMode && 
                                            <CustomButton
                                                id="add_new_user_submit"
                                                buttonType="submit"
                                                label="Send Invitation"
                                                type="primaryBtn"
                                                backicon={
                                                    isSubmittedActionPending === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                                        : ''
                                                }
                                                disabled={isSubmittedActionPending === true ? true : false}
                                            />
                                        }
                                        {!props.isCreateMode && 
                                            <CustomButton
                                                id="edit_user_submit"
                                                buttonType="submit"
                                                label="Save User"
                                                type="primaryBtn"
                                                backicon={
                                                    isSubmittedActionPending === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                                        : ''
                                                }
                                                disabled={isSubmittedActionPending === true ? true : false}
                                            />
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </Form>
                )}
            </Formik>
        </div >
    )
}
export default UserDetails;
